module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/pevc-career-talk-session-2.json
// module id = 1453
// module chunks = 275744444138559